<template>
<div class="LeaderTotal">
    <div class="summary">
        <div class="box bgc box-shadow">
            <div class="name">销售订单数</div>
            <div class="value">{{summary.ordercount}}</div>
        </div>
        <div class="box bgc box-shadow">
            <div class="name">总销售额</div>
            <div class="value">￥{{summary.totalmoney}}</div>
        </div>
    </div>
    <saleData ref="saleData" :summary="summary"></saleData>
    <brokerageSale ref="brokerageSale" :summary="summary"></brokerageSale>
    <brokeragetotal ref="brokeragetotal" :summary="summary"></brokeragetotal>
</div>
</template>

<script>
import {mapActions} from 'vuex'
import {dateFormat} from 'common/js/tools'
import {getDataSummaryByHeader} from 'api/brandBusiness'
import SaleData from 'views/brandBusiness/leaderMgt/myLeader/components/saleData.vue'
import BrokerageSale from 'views/brandBusiness/leaderMgt/myLeader/components/brokerageSale.vue'
import Brokeragetotal from 'views/brandBusiness/leaderMgt/myLeader/components/brokeragetotal.vue'
export default {
    name: 'LeaderTotal',
    data() {
        return {
            summary: {
                brokerageheader: '0.00', // 团长佣金
                brokeragepayed: '0.00', // 已收佣金
                brokeragerecommend: '0.00', // 推荐佣金
                brokeragesale: '0.00', // 商品佣金
                brokeragesettled: '0.00', // 待发佣金
                brokeragetotal: '0.00', // 合计佣金
                ordercount: 0, // 销售订单数
                totalmoney: '0.00', // 销售额
            },
            param: {
                headerinnerid: this.$route.query.headerinnerid ? this.$route.query.headerinnerid : ''
            },
        }
    },
    mounted() {
        this._getDataSummaryByHeader()
    },
    methods: {
        _getDataSummaryByHeader() {
            this.setLoading(true)
            getDataSummaryByHeader({
                data: Object.assign({}, this.param),
                success: data => {
                    this.summary = data.data
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions(['setLoading'])
    },
    filters: {},
    watch: {},
    computed: {},
    components: {
        SaleData, BrokerageSale, Brokeragetotal
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/index";
.LeaderTotal {
    .summary{
        display: flex;
        .box{
            flex-grow: 1;
            height: 120px;
            padding: 30px;
            box-sizing: border-box;
            .name{
                margin-bottom: 16px;
            }
            .value{
                color: #409EFF;
                font-size: 24px;
            }
        }
        .box+.box{
            margin-left: 30px;
        }
    }
    .filters{
        margin-bottom: 0 !important;
        border-bottom: 1px solid $line;
        padding: 20px 10px;
        .add .el-button{
            min-width: 48px;
            font-size: 12px;
        }
        .search .el-button{
            min-width: 72px;
            font-size: 12px;
        }
        .dateInput{
            margin-right: 10px;
            width: 240px;
            height: 36px;
        }
        .el-button.is-disabled, .el-button.is-disabled:focus, .el-button.is-disabled:hover{
            cursor: pointer;
        }
        .el-date-editor .el-range-separator{
            line-height: 28px;
        }
    }
    .echert{
        margin: 10px;
    }
    .lineDatas{
        background: $bgcolor-white;
    }
    .lineReport{
        flex-grow: 1;
    }
    .total{
        height: 420px;
        display: flex;
        justify-content: flex-start;
        background: #fff;
        .left{
            padding: 0 10px;
            box-sizing: border-box;
            background: #fff;
            width: 240px;
            min-width: 240px;
            max-width: 240px;
            height: 100%;
            border-right: 1px solid #DCDFE6;
            .outbox{
                height:100%;
                box-sizing: border-box;
                .innerbox{
                    display: flex;
                    justify-content: space-between;
                    flex-direction: column;
                    height: 100%;
                    .box{
                        width: 100%;
                        flex-grow: 1;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        .name{
                            font-size: 12px;
                            margin-bottom: 10px;
                            display: flex;
                            align-items: center;
                            .tip{
                                margin-left: 6px;
                                display: inline-block;
                                width: 12px;
                                height: 12px;
                            }
                        }
                        .value{
                            font-size: 24px;
                        }
                    }
                    .box+.box{
                        border-top: 1px solid #DCDFE6 ;
                    }
                }
            }
            .outbox+.outbox{
                border-top: 1px solid $line;
            }
        }
        .right{
            flex-grow: 1;
            overflow: hidden;
        }
    }
}
</style>
